import { Card } from "@circleco/compass/components/Card";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { PartnerBadgeAnimatedBorder } from "./PartnerBadgeAnimatedBorder";
import { useCirclePartnerBadge } from "./useCirclePartnerBadge";

export const CirclePartnerBadgeCard = () => {
  const { shouldShow, title, description, onClick } = useCirclePartnerBadge();

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="shrink-0 p-3">
      <PartnerBadgeAnimatedBorder className="shadow-sm">
        <Card.Root onClick={onClick}>
          <Card.Body className="p-3">
            <div className="flex items-start gap-3">
              <Icon name="heart-handshake" size="md" color="primary" />
              <div className="flex flex-col gap-0.5">
                <Typography variant="label-sm" color="primary" component="p">
                  {title}
                </Typography>
                <Typography variant="caption" color="tertiary" component="p">
                  {description}
                </Typography>
              </div>
            </div>
          </Card.Body>
        </Card.Root>
      </PartnerBadgeAnimatedBorder>
    </div>
  );
};
